<template>
  <el-dialog
    title="添加任务"
    :visible.sync="isShow"
    width="1200px"
    center
    @close="$emit('close')"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="add-video-warp-box">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <div class="flex-item">
          <el-form-item label="上传类型:" prop="mediaType">
            <el-select
              @change="handleType()"
              v-model="form.mediaType"
              size="small"
              placeholder="请选择上传类型"
              clearable
            >
              <el-option value="video" label="视频"></el-option>
              <el-option value="image" label="漫画"></el-option>
              <el-option value="text" label="小说"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select
              @change="getTagDimensionsList()"
              v-model="form.type"
              placeholder="请选择类型"
              size="small"
              clearable
            >
              <el-option
                v-for="k in types"
                :key="k.value"
                :label="k.label"
                :value="k.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维度" prop="dimension">
            <el-select
              @change="getTagList"
              v-model="form.dimension"
              placeholder="请选择维度"
              size="small"
              clearable
            >
              <el-option
                v-for="k in dimensions"
                :key="k.id"
                :label="k.name"
                :value="k.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排版方向:" prop="direction">
            <el-select
              v-model="form.direction"
              size="small"
              placeholder="请选择排版方向"
              clearable
            >
              <el-option :value="0" label="横"></el-option>
              <el-option :value="1" label="竖"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="售卖类型:" prop="sellType">
            <el-select
              v-if="form.mediaType === 'video'"
              v-model="form.sellType"
              size="small"
              placeholder="请选择售卖类型"
              clearable
            >
              <el-option :value="0" label="单集"></el-option>
              <el-option :value="1" label="整部"></el-option>
            </el-select>
            <el-select
              v-else
              :disabled="true"
              v-model="form.sellType"
              size="small"
              placeholder="请选择售卖类型"
              clearable
            >
              <el-option :value="0" label="单集"></el-option>
              <el-option :value="1" label="整部"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否激活:" prop="isActive">
            <el-select
              v-if="form.mediaType !== 'video'"
              v-model="form.isActive"
              size="small"
              placeholder="请选择是否激活"
              clearable
            >
              <el-option :value="true" label="是"></el-option>
              <el-option :value="false" label="否"></el-option>
            </el-select>
            <el-select
              v-else
              :disabled="true"
              v-model="form.isActive"
              size="small"
              placeholder="请选择是否激活"
              clearable
            >
              <el-option :value="true" label="是"></el-option>
              <el-option :value="false" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收费类型:" prop="listenPermission">
            <el-select
              v-model="form.listenPermission"
              size="small"
              placeholder="请选择收费类型"
              clearable
            >
              <el-option :value="0" label="会员"></el-option>
              <el-option :value="1" label="金币"></el-option>
              <el-option :value="2" label="免费"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="更新状态" prop="dimension">
            <el-select
              @change="changeUpdateSta"
              v-model="form.updateStatus"
              placeholder="请选择状态"
              size="small"
            >
              <el-option
                v-for="k in updateTypes"
                :key="k.value"
                :label="k.label"
                :value="k.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div
          class="flex-item"
          v-if="form.mediaType === 'video' || form.mediaType === 'video_adv'"
        >
          <el-form-item label="上传视频:">
            <input
              type="file"
              @change="changeFile"
              accept="video/*"
              id="inputFile"
            />
          </el-form-item>
          <el-form-item label="横版封面上传:" prop="horizontalCover">
            <base-upload
              :cover="form.horizontalCover"
              :action="action"
              @successCallback="successCallbackHeng"
              :id="form.sourceID"
              :wSize="640"
              :hSize="360"
              :width="'213px'"
              :height="'120px'"
            ></base-upload>
          </el-form-item>
          <el-form-item label="竖版封面上传:" prop="verticalCover">
            <base-upload
              :cover="form.verticalCover"
              :action="action"
              @successCallback="successCallbackShu"
              :id="form.sourceID"
              :wSize="360"
              :hSize="640"
              :width="'120px'"
              :height="'213px'"
            ></base-upload>
          </el-form-item>
        </div>
        <div class="flex-item" v-if="form.mediaType === 'text'">
          <!--小说音频上传-->
          <el-upload
            accept="audio/mp3"
            class="upload-demo"
            :action="actionAudio"
            :headers="header"
            :on-success="handleTrialChange"
            :file-list="fileList"
            :limit="1"
          >
            <el-button size="small" type="success" class="uploadMp3"
              >点击上传</el-button
            >
          </el-upload>
          <el-form-item label="作者:">
            <el-input
              type="text"
              placeholder="请输入作者"
              v-model="form.author"
              size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item
            style="width: 1100px"
            label="上传图集:"
            prop="cover"
            v-if="form.mediaType === 'image'"
          >
            <!--上传图集-->
            <imgs-upload
              :cover="form.cover"
              :action="actionPics"
              @successCallback="successCallbackPic"
              :id="form.sourceID"
              :wSize="180"
              :hSize="320"
              :width="'100px'"
              :height="'100px'"
              ref="uploadImgs"
            ></imgs-upload>
          </el-form-item>
          <el-form-item
            style="width: 1100px"
            label="小说内容:"
            prop="cover"
            v-if="form.mediaType === 'text'"
          >
            <!--小说-->
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入小说内容"
              v-model="form.text"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="横版封面上传:"
            prop="horizontalCover"
            v-if="form.mediaType === 'image' || form.mediaType === 'text'"
          >
            <base-upload
              :cover="form.horizontalCover"
              :action="action"
              @successCallback="successCallbackHeng"
              :id="form.sourceID"
              :wSize="640"
              :hSize="360"
              :width="'213px'"
              :height="'120px'"
            ></base-upload>
          </el-form-item>
          <el-form-item
            label="竖版封面上传:"
            prop="verticalCover"
            v-if="form.mediaType === 'image' || form.mediaType === 'text'"
          >
            <base-upload
              :cover="form.verticalCover"
              :action="action"
              @successCallback="successCallbackShu"
              :id="form.sourceID"
              :wSize="360"
              :hSize="640"
              :width="'120px'"
              :height="'213px'"
            ></base-upload>
          </el-form-item>
        </div>
        <el-form-item
          label="更新描述:"
          class="updatedDesc"
          v-if="form.updateStatus != 0"
        >
          <el-input
            type="text"
            placeholder="请输入更新描述"
            v-model="form.updatedDesc"
          ></el-input>
        </el-form-item>
        <div class="flex-item" v-if="form.listenPermission === 1">
          <el-form-item label="帖子定价:" prop="coins">
            <el-input v-model.number="form.coins" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="种类" prop="kind">
            <el-select
              v-model="form.kind"
              placeholder="请选择种类"
              size="small"
              clearable
            >
              <el-option
                v-for="k in kinds"
                :key="k.value"
                :label="k.label"
                :value="k.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总集数:" prop="totalEpisode">
            <el-input
              v-model.number="form.totalEpisode"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="集数:" prop="episodeNumber">
            <el-input
              :disabled="true"
              v-model.number="form.episodeNumber"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="集数名:" prop="episodeNumberName">
            <el-input v-model="form.episodeNumberName" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="标题:">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入标题"
              v-model="form.title"
            ></el-input>
          </el-form-item>
          <el-form-item label="简介:">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入媒体简介"
              v-model="form.summary"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="标签:" prop="tag">
            <tag-selector v-model="tag" :tagList="tagList"></tag-selector>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitDate"
            >立即添加</el-button
          >
          <el-button size="small" @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { validatorIndex } from "@/utils/validator";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import API from "@/api";
import TagSelector from "@/components/tagSelector";
export default {
  props: ["isShow"],
  data() {
    return {
      SeriesCover: [],
      trackId: "",
      show: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStaticBatch",
      // 音频上传地址
      actionAudio: baseConfig.baseServerUrl + "/vid/upload/audio",
      // 视频播放地址
      videoBaseUrl: baseConfig.playVideoUrl,
      header: {
        Authorization: local.get("userInfo").token,
      },
      isFree: true,
      flag: false,
      player: "",
      files: null,
      tag: [],
      // 表单数据
      form: {
        title: "",
        author: "",
        mediaType: "", //上传文件类型
        horizontalCover: "",
        verticalCover: "",
        tags: [],
        summary: "",
        totalEpisode: undefined,
        episodeNumber: 1,
        episodeNumberName: "",
        kind: undefined,
        dimension: undefined,
        price: 0,
        direction: 0,
        sellType: undefined,
        isActive: false,
        text: "", //小说专用
        sourceID: "",
        filename: "",
        resolution: "",
        md5: "",
        seriesCover: [],
        listenPermission: 0,
        updateStatus: 0,
        updatedDesc: undefined,
      },
      dimensions: [],
      tagList: [], //标签列表：包含标签名称和标签id
      updateTypes: [
        { label: "默认", value: 0 },
        { label: "更新中", value: 1 },
        { label: "已完结", value: 2 },
      ],
      types: [
        {
          label: "动漫",
          value: 1,
        },
        {
          label: "漫画",
          value: 2,
        },
      ],
      kinds: [
        { label: "哩番", value: 1 },
        { label: "3D", value: 2 },
        { label: "同人动画", value: 3 },
        { label: "单行本", value: 4 },
        { label: "连载漫画", value: 5 },
        { label: "韩漫", value: 6 },
        { label: "有声小说", value: 7 },
        { label: "文字小说", value: 8 },
        { label: "剧场动漫", value: 9 },
      ],
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        mediaType: [
          { required: true, message: "请选择上传类型", trigger: "blur" },
        ],
        kind: [{ required: true, message: "请选择种类", trigger: "blur" }],
        direction: [
          { required: true, message: "请选择排版方向", trigger: "blur" },
        ],
        sellType: [
          { required: true, message: "请选择售卖类型", trigger: "blur" },
        ],
        totalEpisode: [
          { required: true, message: "请输入总集数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        episodeNumber: [
          { required: true, message: "请输入集数", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" },
        ],
        episodeNumberName: [
          { required: true, message: "请输入集数名", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    TagSelector,
  },
  // created() {
  //   console.log(213123)
  // },
  methods: {
    changeUpdateSta() {
      if (this.form.updateStatus == 1) {
        this.form.updatedDesc = "更新至X话";
      } else if (this.form.updateStatus == 2) {
        this.form.updatedDesc = "已完结X话";
      } else {
        this.form.updatedDesc = undefined;
      }
    },
    changeFile(event) {
      let files = event.target.files[0];
      this.files = files;
    },
    cancel() {
      this.cleanForm();
      this.$emit("close");
    },
    handleType() {
      if (this.form.mediaType === "video") {
        this.form.sellType = 0;
      } else {
        this.form.sellType = 1;
      }
    },
    getTagList() {
      this.tagList = [];
      if (this.form.type === undefined) {
        this.$message.error("请选择类型");
        return;
      }
      if (this.form.dimension === undefined || this.form.dimension === "") {
        this.$message.error("请选择维度");
        return;
      }
      const param = {
        kind: this.form.kind,
        dimension: this.form.dimension,
      };
      API.getMediaTagByKindDimension(param).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data;
        }
      });
    },
    // 请求种类下的维度列表数据
    getTagDimensionsList() {
      this.tagList = [];
      API.getAnimeAllLatitude({
        type: this.form.kind,
      })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dimensions = res.data.list || [];
          } else {
            this.dimensions = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.dimensions = [];
          this.loading = false;
        });
    },
    // 处理音频
    handleTrialChange(res) {
      if (res.data.code === 200) {
        this.form.audioUrl = res.data.data.fileName;
      } else {
        this.fileList = [];
      }
    },
    // 提交验证
    submitDate() {
      if (this.tag.length <= 0 && this.form.mediaType != 'text') {
        this.$message.error("请选择标签");
        return false;
      }
      for (const t of this.tag) {
        this.form.tags.push(t.id);
      }
      if (this.form.mediaType === "video" && !this.files) {
        this.$message.error("请选择视频");
        return false;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            files: this.files || null,
            form: { ...this.form },
            time: new Date().getTime(),
          };
          this.$emit("addTaskSuccess", data);
          this.$emit("close");
          this.cleanForm();
        } else {
          return false;
        }
      });
    },
    cleanForm() {
      this.files = null;
      let dom = document.querySelector("#inputFile");
      if (dom) {
        dom.value = "";
      }

      // this.form = {
      //   title: "",
      //   mediaType: "", //上传文件类型
      //   horizontalCover: "",
      //   verticalCover: "",
      //   tags: [],
      //   summary: "",
      //   totalEpisode: undefined,
      //   episodeNumber: 1,
      //   episodeNumberName: "",
      //   kind: undefined,
      //   dimension: undefined,
      //   price: 0,
      //   direction: 0,
      //   sellType: undefined,
      //   isActive: false,
      //   text: "",//小说专用
      //   sourceID: "",
      //   filename: "",
      //   resolution: "",
      //   md5: "",
      //   seriesCover: [],
      //   listenPermission: 0,
      //   updatedDesc: undefined,
      //   updateStatus: 0,
      // };

      this.form.title = "";
      this.form.horizontalCover = "";
      this.form.verticalCover = "";
      this.form.tags = [];
      this.form.summary = "";
      this.form.author = "";
      this.form.totalEpisode = undefined;
      this.form.episodeNumber = 1;
      this.form.episodeNumberName = "";
      this.form.price = 0;
      // this.form.sellType = undefined;
      this.form.isActive = false;
      this.form.text = ""; //小说专用
      this.form.sourceID = "";
      this.form.filename = "";
      this.form.resolution = "";
      this.form.md5 = "";
      this.form.seriesCover = [];
      this.form.listenPermission = 0;
      this.form.updateStatus = 0;
      this.form.updatedDesc = undefined;
      this.form.cover = [];
      if (this.$refs.uploadImgs) {
        this.$refs.uploadImgs.clearImg();
      }
      // this.$refs.uploadImgs.clearImg();
      // console.log(this.$refs.uploadImgs)

      // this.tagList = [];
      // this.tag = [];
    },
    // 封面图上传成功回调
    successCallbackHeng(res) {
      this.form.horizontalCover = res.data.coverImg;
    },
    successCallbackShu(res) {
      this.form.verticalCover = res.data.coverImg;
    },
    // 封面图上传成功回调
    successCallbackPic(seriesCover) {
      this.form.seriesCover = seriesCover;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-video-warp-box {
  /deep/ .el-form-item__content {
    display: flex;
  }
  .flex-item {
    width: 90%;
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .el-upload .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }
  .el-textarea {
    width: 500px;
  }
  .el-input {
    width: 250px;
  }
  .uploader-drop {
    background: none;
    border-radius: 5px;
    border: none;
    padding: 0;
  }
  .uploader-file {
    border-bottom: 1px dashed #ccc;
  }
  .uploader-btn {
    background: #e63765;
    color: white;
    padding: 5px 10px;
    font-size: 13px;
    border: none;
    border-radius: 3px;
    &:hover {
      background: #eb5f84;
    }
  }
  .title {
    width: 100%;
    height: 30px;
    display: inline-block;
    font-size: 14px;
    line-height: 30px;
    overflow: hidden;
    color: #666;
    margin-bottom: 15px;
    cursor: pointer;
    i {
      &:hover {
        color: #e63765;
      }
    }
    span {
      margin-left: 10px;
    }
  }
  .upload-video {
    width: 300px !important;
    .circle-bar {
      width: 100%;
      height: 100%;
      text-align: center;
      .el-progress-circle {
        margin: 0 auto;
        margin-top: 8px;
      }
    }
    .video-box {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
.show {
  left: 20px;
  transition: left 0.2s linear;
}
.upload-demo {
  display: flex;
  margin: 5px 0 0 50px;
}
// .uploadMp3 {
//   margin-right: 20px;
// }
</style>
